import tw, { styled } from "twin.macro";
import { motion } from "framer-motion";

// Styled Components
export const Header = styled.header`
	${tw`fixed top-0 w-full z-50 flex justify-center items-center px-4 lg:px-0 lg:py-4 py-2`}

	background: rgba(255, 255, 255, 0.1); /* Transparent background */
	backdrop-filter: blur(25px); /* Glass effect */
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
	border-bottom: 1px solid rgba(255, 255, 255, 0.3); /* Optional border to distinguish header from content */
`;
export const HeaderContainer = tw.div`
  w-full max-w-screen-xl mx-0 md:mx-8  flex justify-between items-center 
`;

export const NavLinks = tw.div`inline-block`;

export const NavLink = styled.a(({ isActive }) => [
	tw`text-lg my-2 lg:text-sm lg:mx-6 lg:my-0 cursor-pointer
  font-semibold tracking-wide transition duration-300 pb-1 border-b-2`,

	// Default (unactive): Neutral gray text and no underline
	tw`text-gray-500 border-transparent`, // Medium gray for good visibility on both backgrounds

	// Hover: Light blue text and underline
	tw`hover:text-blue-600 hover:border-blue-400`,

	// Active: Same as hover, light blue text and underline
	isActive && tw`text-blue-600 border-blue-400`,
]);

export const PrimaryLink = tw(NavLink)`
  lg:mx-0
  px-8 py-3 rounded bg-primary-500 text-gray-100
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0
`;

export const LogoLink = styled(NavLink)`
	${tw`flex items-center font-black border-b-0 md:text-2xl! text-lg! ml-0!`};

	img {
		${tw`w-14 mr-3`}
	}
`;

export const DesktopNavLinks = styled.nav`
	${tw`hidden flex-1 justify-between items-center`}

	@media (min-width: 1024px) {
		/* lg breakpoint */
		${tw`flex`}
	}
`;

export const MobileNavLinksContainer = styled.nav`
	${tw`flex flex-1 items-center justify-between relative z-30`}

	@media (min-width: 1024px) {
		/* lg breakpoint */
		${tw`hidden`}
	}
`;

export const MobileNavLinks = motion(styled.div`
	${tw`fixed top-0 inset-x-0 mx-4 my-6 p-8 border text-center rounded-lg text-gray-900 bg-white z-10`}
	${tw`overflow-hidden`}
  ${NavLinks} {
		${tw`flex flex-col items-center`}
	}
`);

export const MobileMenusWrapper = styled.div`
	${tw`flex justify-between items-center w-24`}

	@media (min-width: 1024px) {
		/* lg breakpoint */
		${tw`hidden`}
	}
`;

export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hocus:text-primary-500 transition duration-300
`;

export const LanguageSwitcherContainer = styled.div`
	${tw`relative inline-block text-left`}
`;

export const LanguageMenu = styled(motion.div)`
	${tw`origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50`}
`;

export const LanguageMenuItem = styled.a`
	${tw`block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 cursor-pointer`}
`;

export const LanguageSwitcherButton = tw.button`
  px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-700 shadow-sm 
  hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500
`;
